export enum AnalyticsIncomeSources {
  UNREALIZED_GAIN_OR_LOSS = 'Unrealized Gain or Loss',
  INCOME_AND_EXPENSE = 'Income & Expense',
  EXCLUDE_TRANSFER = 'Exclude Transfer',
}

export const LEGACY_UNREALIZED_GAIN_INCOME_SOURCE = 'Unrealized Gain & Income'

export const hasUnrealizedGainOrLossSource = (source: readonly string[]) =>
  source.includes(AnalyticsIncomeSources.UNREALIZED_GAIN_OR_LOSS)
  || source.includes(LEGACY_UNREALIZED_GAIN_INCOME_SOURCE)
